export default __webpack_public_path__ + "static/media/logo-flow.01a6002c.webp";